import { useEffect, useRef, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { HiOutlineUsers } from "react-icons/hi";
import { BsBoxSeam } from "react-icons/bs";
import { TbWorld } from "react-icons/tb";
import { RiLineChartLine } from "react-icons/ri";
import "./success.css";

const stats = [
  {
    icon: <HiOutlineUsers />,
    value: 60,
    suffix: "+",
    label: "Clients Served",
    sub: "Helping businesses grow with result-driven marketing",
  },
  {
    icon: <BsBoxSeam />,
    value: 500,
    suffix: "+",
    label: "Campaigns Executed",
    sub: "High-performing campaigns across industries",
  },
  {
    icon: <TbWorld />,
    value: 10,
    suffix: "+",
    label: "Industries Worked With",
    sub: "Diverse experience across multiple business sectors",
  },
  {
    icon: <RiLineChartLine />,
    value: 98,
    suffix: "%",
    label: "Client Retention",
    sub: "Built on trust, performance, and consistent results",
  },
];

function useCountUp(target, active, duration = 1800) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!active) {
      setCount(0);
      return;
    }
    let start = null;
    const step = (ts) => {
      if (!start) start = ts;
      const progress = Math.min((ts - start) / duration, 1);
      // ease out cubic
      const eased = 1 - Math.pow(1 - progress, 3);
      setCount(Math.floor(eased * target));
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [active, target, duration]);

  return count;
}

function StatCard({ icon, value, suffix, label, sub, active }) {
  const count = useCountUp(value, active);
  return (
    <div className="stat-card">
      <span className="stat-icon">{icon}</span>
      <div className="stat-value">
        {count}
        {suffix}
      </div>
      <div className="stat-label">{label}</div>
      <div className="stat-sub">{sub}</div>
    </div>
  );
}

export const Success = () => {
  const sectionRef = useRef(null);
  const [active, setActive] = useState(false);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry]) => setActive(entry.isIntersecting),
      { threshold: 0.3 },
    );
    if (sectionRef.current) obs.observe(sectionRef.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section className="success-section" ref={sectionRef}>
      <Container>
        <Row className="align-items-center gy-5">
          {/* Left copy */}
          <Col xs={12} lg={5}>
            <p className="success-eyebrow">— Proven Results That Speak</p>
            <h2 className="success-heading">
              Driving Business Growth <br /> Through
              <span className="success-highlight"> Data-Driven Strategies</span>
            </h2>
            <p className="success-desc">
              We help businesses increase online visibility, generate consistent
              leads and maximize ROI with performance-focused strategies. From
              startups to growing brands, our solutions are designed to deliver
              measurable results and long-term growth.
            </p>
            <div className="success-actions">
              <Link to="/contact" className="btn-become">
                Get Started →
              </Link>
              <Link to="/projects" className="btn-work">
                View Our Work
              </Link>
            </div>
          </Col>

          {/* Right stats grid */}
          <Col xs={12} lg={7}>
            <Row className="g-3">
              {stats.map((s, i) => (
                <Col xs={6} key={i}>
                  <StatCard {...s} active={active} />
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
